// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  label: {
    color: GlobalStyles.color.COLOR_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  fixedWidth: {
    width: '300px !important',
  },
  width: {
    width: '100%',
  },
  textarea: {
    margin: '5px 0 10px 0',
    resize: 'none',
    height: '100px !important',
    '&::placeholder': {
      color: GlobalStyles.color.COLOR_GREY,
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    },
  },
});

export default styles;
